<template>
  <div>
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Line } from 'vue-chartjs';

export default {
  name: 'LineChartWrapper',
  extends: Line,
  props: {
    categoryWiseTalents: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    categoryWiseTalents: {
      handler(newData) {
        this.renderChart({
          labels: newData.map(item => item.category),
          datasets: [
            {
              label: 'Total Talents',
              backgroundColor: 'rgba(75,192,192,0.2)',
              borderColor: '#4bc0c0',
              pointBackgroundColor: '#4bc0c0',
              data: newData.map(item => item.totalTalents),
              fill: false,
              lineTension: 0.4,
            },
          ],
        }, {
          responsive: true,
          maintainAspectRatio: false,
        });
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped>
div {
  height: 300px;
}
</style>
